export default {
  series: 1,
  data: 'Category;A;B;C\n0;8;1;1\n1;7;2;8\n2;6;3;2\n3;5;4;7\n4;4;5;3\n5;3;6;6\n6;2;7;4\n7;1;8;5',
};
